import {WidgetConfig} from "../../types/config";
import {ClientErrorLogger} from "./clientErrorLogger";

export class DomainValidator {
    private config: WidgetConfig;
    private readonly appDomain: string;
    private readonly targetLink: string;

    private targetDomain: string = '';
    private fullTargetLink: string = '';

    constructor(config: WidgetConfig, appDomain: string, targetLink: string) {
        this.config = config;
        this.appDomain = appDomain;
        this.targetLink = targetLink;

        this.initDomainData();
        this.normalizeLink();
    }

    public isValid(): boolean
    {
        if (this.fullTargetLink == '') {
            return false;
        }

        if(this.appDomain === this.targetDomain) {
            return true;
        }

        return this.isAllowedHostname();
    }

    public getLink(): string
    {
        return this.fullTargetLink;
    }

    public getLinkTarget(): string
    {
        if(this.appDomain === this.targetDomain) {
            return '_self';
        }

        return '_blank';
    }

    private isAllowedHostname(): boolean {
        const hostParts = this.targetDomain.split('.');
        if (hostParts.length < 2) {
            return false;
        }

        const baseDomain = hostParts.slice(-2).join('.');
        if (!this.config.getAllowedLinkBaseDomains().has(baseDomain)) {
            return false;
        }

        if (hostParts.length === 2) {
            return true;
        }

        const normalizedSubdomain = this.removeStagingPrefix(hostParts[0]);
        return this.config.getAllowedLinkSubdomains().has(normalizedSubdomain);
    }

    private removeStagingPrefix(label: string): string {
        return label.startsWith('staging-') ? label.substring('staging-'.length) : label;
    }

    private initDomainData(): void
    {
        let url: URL;

        try{
            url = new URL(this.targetLink, window.location.href);
        } catch (e) {
            let message = 'Invalid target link: ' + this.targetLink;
            (new ClientErrorLogger()).logInfo(message);
            return;
        }

        this.targetDomain = url.hostname.toLowerCase();
        this.fullTargetLink = url.toString();
    }

    private normalizeLink(): void
    {
        if(this.appDomain.includes('staging-')) {
            let stagingTargetDomain = 'staging-' + this.targetDomain;
            if(stagingTargetDomain === this.appDomain) {
                this.fullTargetLink = this.fullTargetLink.replace(this.targetDomain, stagingTargetDomain);
                this.targetDomain = stagingTargetDomain;
            }
        }
    }


}